import { DeleteDocument } from '@/api/document.js'
import i18n from '@/locales/i18n'

// Only documents uploaded in the portal can be removed, and only by internal users
export function canRemoveDocument (store, documentInfo) {
  return store.getters['account/canDeleteDocuments'] && documentInfo?.UploadedInPortal === true
}

// Asks for confirmation and removes the document from the portal. Resolves true when it was removed.
export async function confirmAndRemoveDocument (documentInfo, toast) {
  const fileName = `${documentInfo.Name}.${documentInfo.Extension}`
  if (!window.confirm(i18n.global.t('documentPage.removeConfirm', { name: fileName }))) {
    return false
  }
  try {
    await DeleteDocument(documentInfo.Id)
    toast.success(i18n.global.t('documentPage.removeSuccess'))
    return true
  } catch (e) {
    toast.error(i18n.global.t('documentPage.removeFailed'))
    return false
  }
}
